module.exports = __webpack_public_path__ + "assets/img/tx280s.2aa31289.jpg";